const base64js = require('base64-js');
import Validator from 'validatorjs';

/* @ngInject */
export default class ClearanceCaptureCtrl {
    constructor($scope, $rootScope, $timeout, ClearanceCaptureService, NotificationService, LocalStorageService) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.LocalStorageService = LocalStorageService;
        this.NotificationService = NotificationService;
        this.ClearanceCaptureService = ClearanceCaptureService;

        this.init();
        this._registerEventHandler();
        this.activate();
    }

    init() {
        this.isBusy = false;
        this.howToGuideLink;
        this.attachment = {};
        this.documentType = '0';
        this.isLegalEntity = false;
        this.validPurchaser = false;
        this.isPurchaserBusy = false;
        this.selectedAttachment = {};
        this.selectedPurchaserId = '';
        this.purchaserConfirms = false;
        this.purchaseDocumentType = '0';
        this.hasSelectedPurchaser = false;
        this.isInAddPurchaserMode = false;
        this.isInEditPurchaserMode = false;
        this.showOtherMaritalStatus = false;
        this.hasClearanceHeaderBeenSaved = false;
        this.formsErrors = {
            first: [],
            second: [],
            header: []
        };

        this.documentsErrors = {
            first: [],
            second: [],
            header: []
        };

        this.purchaser = {
            MaritalStatus: undefined,
            OtherMaritalStatus: undefined
        };

        this.documentTypeList = [
            {
                Value: 1,
                Description: 'Id Document'
            },
            {
                Value: 2,
                Description: 'Proof Of Residence'
            }
        ];
        this.documentTypeListLoaded = [{}];
        this.headerDocumentsAlreadyUpLoaded = [{}];

        this.entityTypes = [
            {
                value: 'natural',
                text: 'Natural'
            },
            {
                value: 'legal-entity',
                text: 'Legal Entity'
            }
        ];

        this.legalEntities = [
            {
                value: 1,
                text: 'Close Corporation'
            },
            {
                value: 2,
                text: 'Trust'
            },
            {
                value: 3,
                text: 'Company'
            }
        ];

        this.purchaserTypes = [
            {
                value: 1,
                text: 'Occupant (O)'
            },
            {
                value: 2,
                text: 'Investor (I)'
            }
        ];

        this.purchaseDocTypes = [{}];

        this.hoaDocument = {
            Value: 3,
            Description: 'Hoa Membership Form'
        };

        this.acknowledgementOfRules = {
            Value: 6,
            Description: 'Acknowledgement of Rules'
        };

        this.companyRegistrationDocument = {
            Value: 4,
            Description: 'Company Registration Document'
        };

        this.clearanceHeader = {
            postCode: null,
            vatRegNo: null,
            attachments: [],
            addressLineOne: '',
            addressLineTwo: '',
            addressLineFour: '',
            addressLineThree: '',
            registrationNo: null,
            dateValidUntil: null,
            selectedEntityType: null,
            selectedLegalEntity: null,
            pretorToHandleRental: true,
            selectedPurchaserType: null,
            dateOfRegistration: null,
            SellerBankName: '',
            SellerBankAccountName: '',
            SellerBankAccountNumber: null,
            SellerBankBranchCode: null,
        };
    }

    _registerEventHandler() {
        this.$scope.$watch('clearanceCaptureVm.purchaser.MaritalStatus', (newVal, oldVal) => {
            if (newVal && newVal === '-1') {
                this.showOtherMaritalStatus = true;
            } else {
                this.showOtherMaritalStatus = false;
            }
        });

        this.$scope.$watch(
            'clearanceCaptureVm.ClearanceCaptureService.clearanceCapture.Purchaser',
            (newValue, oldValue) => {
                this.readyForSubmit();
            },
            true
        );
    }

    changeSelectedEntityType() {
        this.createMainAttachmentList();
        this.$rootScope.$broadcast('clearance-selected-entity-type-changed', null);
    }

    async saveClearanceHeader() {
        this._switchIsBusy(true);
        const purchaserType = this.purchaserTypes.find((type) => {
            if (type.value.toString() === this.clearanceHeader.selectedPurchaserType) {
                return type;
            }
        });

        const PurchaserStatus = purchaserType ? parseInt(purchaserType.value) : null;

        const IsLegalEntity = this.clearanceHeader.selectedEntityType === 'legal-entity' ? true : false;

        const { Id, Attorney, CardCode, AttorneyReference } = this.ClearanceCaptureService.clearanceCapture;

        let ValidDate = moment(this.ClearanceCaptureService.clearanceCapture.ValidDate).endOf('month').toDate();

        let LegalEntity = null;
        if (IsLegalEntity) {
            LegalEntity = {
                Id: this.clearanceHeader.legalEntityId,
                ClearanceHeaderId: Id,
                Name: this.clearanceHeader.name,
                PostCode: this.clearanceHeader.postCode,
                VatRegNumber: this.clearanceHeader.vatRegNo,
                AddressOne: this.clearanceHeader.addressLineOne,
                AddressTwo: this.clearanceHeader.addressLineTwo,
                AddressFour: this.clearanceHeader.addressLineFour,
                AddressThree: this.clearanceHeader.addressLineThree,
                RegistrationNumber: this.clearanceHeader.registrationNo,
                TypeOfLegalEntity: this.clearanceHeader.selectedLegalEntity
                    ? this.legalEntities.find((type) => {
                        if (type.value == this.clearanceHeader.selectedLegalEntity) {
                            return type;
                        }
                    }).value
                    : this.ClearanceCaptureService.clearanceCapture.LegalEntity.TypeOfLegalEntity
            };
        }

        const payload = {
            Id,
            Attorney,
            CardCode,
            ValidDate,
            LegalEntity,
            IsLegalEntity,
            PurchaserStatus,
            AttorneyReference,
            PretorToHandleRental: this.clearanceHeader.pretorToHandleRental,
            SellerBankName: this.clearanceHeader.SellerBankName,
            SellerBankAccountName: this.clearanceHeader.SellerBankAccountName,
            SellerBankAccountNumber: this.clearanceHeader.SellerBankAccountNumber,
            SellerBankBranchCode: this.clearanceHeader.SellerBankBranchCode,
        };

        try {
            await this.ClearanceCaptureService.saveClearanceHeader(payload);
            this.addAttachment();

            this.submitErrorMessage = '';
            this.headerForm.$setPristine();
        } catch (error) {
            console.error(error);
        }
    }

    async saveClearanceRegHeaderAttachment() {
        this._switchIsBusy(true);
        const { Id, DateOfRegistration } = this.ClearanceCaptureService.clearanceCapture;
        const attachment = this.attachment;

        try {
            await this.ClearanceCaptureService.saveClearanceRegHeaderAttachment(DateOfRegistration, attachment);
            this.submitErrorMessage = '';
            this.clearPage();
            this.getClearanceHeaderInformation();
            this.NotificationService.success('REGISTRATION DOCUMENT SUBMITTED');
        } catch (error) {
            console.error(error);
            this.NotificationService.error('REGISTRATION DOCUMENT ERROR');
        }
        this._switchIsBusy(false);
    }

    activate() {
        this.howToGuideLink = `${PretorCDNAddress}${PretorCDNAddress.endsWith('/')
            ? ''
            : '/'}docs/Clearance How-To-Guide.pdf`;

        this.defineDefaultPurchaser();
        this.getClearanceHeaderInformation(true);
        this.setupStyles();
        this.addMainAttachmentWatch();
        this.addPersonAttachmentWatch();
        this.getMaritalStatuses();
        this.getBankingInstitutionName();
        this._initializeDatePicker();
    }

    async getMaritalStatuses() {
        this.$timeout(async () => {
            if (!this.isBusy) {
                this._switchIsBusy(true);
            }

            await this.ClearanceCaptureService.getMaritalStatuses();
            if (this.isBusy) {
                this._switchIsBusy(false);
            }
        });
    }
    async getBankingInstitutionName() {
        this.$timeout(async () => {
            if (!this.isBusy) {
                this._switchIsBusy(true);
            }
            await this.ClearanceCaptureService.getBankingInstitutionName();
            if (this.isBusy) {
                this._switchIsBusy(false);
            }
        });
    }

    setupStyles(tabNumber) {
        this.$timeout(() => {
            if (!tabNumber) {
                $(
                    '#purchaserInformation div[ng-if="!clearanceCaptureVm.isLegalEntity"] span.purchaser-tab:last-child'
                ).removeClass('purchaser-tab-selected');
                $(
                    '#purchaserInformation div[ng-if="!clearanceCaptureVm.isLegalEntity"] span.purchaser-tab:nth-child(2)'
                ).addClass('purchaser-tab-selected');
            } else {
                $(
                    '#purchaserInformation div[ng-if="!clearanceCaptureVm.isLegalEntity"] span.purchaser-tab:last-child'
                ).addClass('purchaser-tab-selected');
                $(
                    '#purchaserInformation div[ng-if="!clearanceCaptureVm.isLegalEntity"] span.purchaser-tab:nth-child(2)'
                ).removeClass('purchaser-tab-selected');
            }
        }, 350);
    }

    async getClearanceHeaderInformation(isInit) {
        this._switchIsBusy(true);
        const isLegalEntity = this.ClearanceCaptureService.clearanceCapture.IsLegalEntity;
        const selectedPurchaser = this.selectedPurchaserId
            ? !isLegalEntity
                ? this.ClearanceCaptureService.clearanceCapture.Purchaser.find(
                    (purchaser) => purchaser.Id == this.selectedPurchaserId
                )
                : this.ClearanceCaptureService.clearanceCapture.LegalEntity.ContactPerson.find(
                    (contactPerson) => contactPerson.Id == this.selectedPurchaserId
                )
            : null;

        this.clearPage();

        const correlationId = this.LocalStorageService.retrieve('clearanceCorrelationId');
        if (correlationId) {
            await this.ClearanceCaptureService.loadClearanceCaptureByCorrelationId(correlationId);

            this.$timeout(() => {
                try {
                    this.getBuildingImportantInformation();
                } catch (error) {
                    console.error(`Clearance-controller: Error - ${error}`);
                }
                this.populateClearanceHeader();
                const is2ndTabSelected = !!selectedPurchaser;
                if (is2ndTabSelected) {
                    this.populatePurchaserForm(selectedPurchaser.Id);
                    this.setupStyles(2);
                } else {
                    this.setupStyles();
                }
            }, 100);
        }
    }

    async getBuildingImportantInformation() {
        this._switchIsBusy(true);
        try {
            await this.ClearanceCaptureService.getSchemeInfo();
            await this.ClearanceCaptureService.getUtilityInfo();
        } catch (err) {
            console.error(err);
        } finally {
            this._switchIsBusy(false);
        }
    }

    populateClearanceHeader() {
        this.hasClearanceHeaderBeenSaved = false;
        if (!this.ClearanceCaptureService.clearanceCapture) {
            this._switchIsBusy(false);
            return false;
        }

        this.clearanceHeader.Id = this.ClearanceCaptureService.clearanceCapture.Id;
        this.clearanceHeader.selectedPurchaserType =
            this.ClearanceCaptureService.clearanceCapture.PurchaserStatus > 0
                ? this.ClearanceCaptureService.clearanceCapture.PurchaserStatus.toString()
                : null;

        if (this.ClearanceCaptureService.clearanceCapture.PurchaserStatus > 0) {
            this.hasClearanceHeaderBeenSaved = true;
        }

        this.clearanceHeader.pretorToHandleRental = this.ClearanceCaptureService.clearanceCapture.PretorToHandleRental;
        this.clearanceHeader.selectedEntityType = this.ClearanceCaptureService.clearanceCapture.IsLegalEntity
            ? 'legal-entity'
            : 'natural';
        this.isLegalEntity = this.ClearanceCaptureService.clearanceCapture.IsLegalEntity;

        if (this.ClearanceCaptureService.clearanceCapture.LegalEntity) {
            this.clearanceHeader.legalEntityId = this.ClearanceCaptureService.clearanceCapture.LegalEntity.Id;
            this.clearanceHeader.name = this.ClearanceCaptureService.clearanceCapture.LegalEntity.Name;
            this.clearanceHeader.addressLineOne = this.ClearanceCaptureService.clearanceCapture.LegalEntity.AddressOne;
            this.clearanceHeader.addressLineTwo = this.ClearanceCaptureService.clearanceCapture.LegalEntity.AddressTwo;
            this.clearanceHeader.addressLineThree = this.ClearanceCaptureService.clearanceCapture.LegalEntity.AddressThree;
            this.clearanceHeader.addressLineFour = this.ClearanceCaptureService.clearanceCapture.LegalEntity.AddressFour;
            this.clearanceHeader.postCode = this.ClearanceCaptureService.clearanceCapture.LegalEntity.PostCode;
            this.clearanceHeader.vatRegNo = this.ClearanceCaptureService.clearanceCapture.LegalEntity.VatRegNumber;
            this.clearanceHeader.selectedLegalEntity =
                this.ClearanceCaptureService.clearanceCapture.LegalEntity.TypeOfLegalEntity > 0
                    ? this.ClearanceCaptureService.clearanceCapture.LegalEntity.TypeOfLegalEntity.toString()
                    : null;
            this.clearanceHeader.registrationNo = this.ClearanceCaptureService.clearanceCapture.LegalEntity.RegistrationNumber;

            if (this.clearanceHeader.name) {
                this.hasClearanceHeaderBeenSaved = true;
            }
        }

        if (
            this.ClearanceCaptureService.clearanceCapture.Purchaser &&
            this.ClearanceCaptureService.clearanceCapture.Purchaser.length > 0
        ) {
            this.populatePurchaserForm(this.ClearanceCaptureService.clearanceCapture.Purchaser[0].Id);
            if (this.clearanceHeader.name) {
                this.hasClearanceHeaderBeenSaved = true;
            }
        } else {
            this.$rootScope.$eval(() => {
                this.$timeout(() => {
                    EQCSS.apply();
                }, 120);
            });
        }

        const dateValidUntil = moment(this.ClearanceCaptureService.clearanceCapture.ValidDate).format(
            'YYYY-MM'
        );

        this.clearanceHeader.dateValidUntil = dateValidUntil;
        if (this.ClearanceCaptureService.clearanceCapture.DateOfRegistration != null) {
            const dateOfRegistration = moment(this.ClearanceCaptureService.clearanceCapture.DateOfRegistration).format(
                'YYYY-MM-DD'
            );
            this.ClearanceCaptureService.clearanceCapture.DateOfRegistration = dateOfRegistration;
        }
        this.clearanceHeader.AttorneyRef = this.ClearanceCaptureService.clearanceCapture.AttorneyReference;
        this.clearanceHeader.SellerBankName = this.ClearanceCaptureService.clearanceCapture.SellerBankName;
        this.clearanceHeader.SellerBankAccountName = this.ClearanceCaptureService.clearanceCapture.SellerBankAccountName;
        this.clearanceHeader.SellerBankAccountNumber = parseInt(this.ClearanceCaptureService.clearanceCapture.SellerBankAccountNumber);
        this.clearanceHeader.SellerBankBranchCode = parseInt(this.ClearanceCaptureService.clearanceCapture.SellerBankBranchCode);
        this._initializeDatePicker();

        this._switchIsBusy(false);
        this.createMainAttachmentList();
        this.addMainAttachmentWatch();
    }

    checkForAtLeastOneContactPerson() {
        const { IsLegalEntity } = this.ClearanceCaptureService.clearanceCapture;
        if (IsLegalEntity) {
            if (
                !(
                    this.ClearanceCaptureService.clearanceCapture.LegalEntity &&
                    (this.ClearanceCaptureService.clearanceCapture.LegalEntity.ContactPerson &&
                        this.ClearanceCaptureService.clearanceCapture.LegalEntity.ContactPerson.length > 0)
                )
            ) {
                return false;
            }
        } else if (
            !(
                this.ClearanceCaptureService.clearanceCapture.Purchaser &&
                this.ClearanceCaptureService.clearanceCapture.Purchaser.length > 0
            )
        ) {
            return false;
        }

        return true;
    }

    readyForSubmit() {
        if (!this.purchaserConfirms) {
            return false;
        }

        let isAtLeastOneContactPerson = this.checkForAtLeastOneContactPerson();
        let canSubmit = false;
        const { IsLegalEntity } = this.ClearanceCaptureService.clearanceCapture;

        let documentsErrors = {
            first: [],
            second: [],
            header: []
        };

        const areDocumentsValid = [];

        if (IsLegalEntity) {
            this.ClearanceCaptureService.clearanceCapture.LegalEntity.ContactPerson.forEach((contactPerson, index) => {
                if (!(contactPerson && contactPerson.ContactPersonAttachment)) {
                    if (areDocumentsValid.length === 0) {
                        areDocumentsValid.push(false);
                        return;
                    }
                }

                const hasIdDocument = !!contactPerson.ContactPersonAttachment.find(
                    (doc) => doc.ClearanceDocumentType == 1
                );

                if (!hasIdDocument) {
                    if (index === 0) {
                        documentsErrors.first = [
                            ...documentsErrors.first,
                            `The ${this.displayLabelForPurchaser} ID Document is required.`
                        ];
                    } else {
                        documentsErrors.second = [
                            ...documentsErrors.second,
                            `The ${this.displayLabelForPurchaser} ID Document is required.`
                        ];
                    }
                }
                areDocumentsValid.push(hasIdDocument);

                const hasProofOfResidence = !!contactPerson.ContactPersonAttachment.find(
                    (doc) => doc.ClearanceDocumentType == 2
                );

                if (!hasProofOfResidence) {
                    if (index === 0) {
                        documentsErrors.first = [
                            ...documentsErrors.first,
                            `The ${this.displayLabelForPurchaser} Proof Of Residence Document is required.`
                        ];
                    } else {
                        documentsErrors.second = [
                            ...documentsErrors.second,
                            `The ${this.displayLabelForPurchaser} Proof Of Residence Document is required.`
                        ];
                    }
                }
                areDocumentsValid.push(hasProofOfResidence);
            });
        } else {
            this.ClearanceCaptureService.clearanceCapture.Purchaser.forEach((purchaser, index) => {
                const hasIdDocument = !!purchaser.PurchaserAttachment.find((doc) => doc.ClearanceDocumentType == 1);
                const hasProofOfResidence = !!purchaser.PurchaserAttachment.find(
                    (doc) => doc.ClearanceDocumentType == 2
                );

                if (!hasIdDocument) {
                    if (index === 0) {
                        documentsErrors.first = [
                            ...documentsErrors.first,
                            `The ${this.displayLabelForPurchaser} ID Document is required.`
                        ];
                    } else {
                        documentsErrors.second = [
                            ...documentsErrors.second,
                            `The ${this.displayLabelForPurchaser} ID Document is required.`
                        ];
                    }
                }
                areDocumentsValid.push(hasIdDocument);

                if (!hasProofOfResidence) {
                    if (index === 0) {
                        documentsErrors.first = [
                            ...documentsErrors.first,
                            `The ${this.displayLabelForPurchaser}  Proof Of Residence Document is required.`
                        ];
                    } else {
                        documentsErrors.second = [
                            ...documentsErrors.second,
                            `The ${this.displayLabelForPurchaser}  Proof Of Residence Document is required.`
                        ];
                    }
                }
                areDocumentsValid.push(hasProofOfResidence);
            });
        }

        let hasHoaDocument = true;
        let hasAcknowledgmentOfRules = false;
        let hasSellerBankingConfirmation = false;

        if (this.isHoa) {
            hasHoaDocument = !!this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment.find(
                (doc) => doc.ClearanceDocumentType == 3
            );
        }

        if (!hasHoaDocument) {
            documentsErrors.header = [...documentsErrors.header, `The HOA Form Document is required.`];
        }
        areDocumentsValid.push(hasHoaDocument);

        hasAcknowledgmentOfRules = !!this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment.find(
            (doc) => doc.ClearanceDocumentType == 6
        );

        if (!hasAcknowledgmentOfRules) {
            documentsErrors.header = [...documentsErrors.header, `The Acknowledgment of Rules Document is required.`];
        }
        areDocumentsValid.push(hasAcknowledgmentOfRules);

        hasSellerBankingConfirmation = !!this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment.find(
            (doc) => doc.ClearanceDocumentType == 8
        );

        if (!hasSellerBankingConfirmation) {
            documentsErrors.header = [...documentsErrors.header, `The Seller Banking Confirmation Document is required.`];
        }
        areDocumentsValid.push(hasSellerBankingConfirmation);

        let hasCompanyRegistrationDoc = true;

        if (this.ClearanceCaptureService.clearanceCapture.IsLegalEntity) {
            hasCompanyRegistrationDoc = !!this.ClearanceCaptureService.clearanceCapture.LegalEntity.LegalEntityAttachment.find(
                (att) => att.ClearanceDocumentType == 4 && !att.IsRejected
            );
        }

        if (!hasCompanyRegistrationDoc) {
            documentsErrors.header = [...documentsErrors.header, `The Company Registration Document is required.`];
        }
        areDocumentsValid.push(hasCompanyRegistrationDoc);

        if (areDocumentsValid.length > 0) {
            let countHowManyAreTrue = areDocumentsValid.filter((obj) => obj == true);
            if (areDocumentsValid.length == countHowManyAreTrue.length) {
                canSubmit = true;
            }
        }

        this.formsErrors = this._getAllFormErrors();
        this.documentsErrors = documentsErrors;

        let allowSubmit = isAtLeastOneContactPerson && canSubmit && this.purchaserConfirms;
        if (allowSubmit) {
            allowSubmit = !this.areFormsDirty && !this.hasErrors;
        }

        return allowSubmit;
    }

    _areFormsValidAndNotDirty() {
        let allowSubmit =
            !(this.headerForm.$error && Object.keys(this.headerForm.$error).length > 0) &&
            !(this.inputForm.$error && Object.keys(this.inputForm.$error).length > 0);

        if (allowSubmit) {
            allowSubmit = !this.inputForm.$dirty && !this.headerForm.$dirty;
            if (!allowSubmit) {
                const error =
                    "Please ensure that you've saved your changes for the " +
                    (this.inputForm.$dirty
                        ? `${this.isLegalEntity ? this.displayLabelForPurchaser : "Purchaser's"}`
                        : `Purchase`);
                this.submitErrorMessage = `${error} Information and try again.`;
            } else {
                this.submitErrorMessage = '';
            }
        }

        return allowSubmit;
    }

    _getAllFormErrors() {
        let results = [];

        const customErrorMessages = {
            numeric: ':attribute must be a number.',
            required: ':attribute is required.',
            email: ':attribute is not a valid email address.'
        };

        const rules = {
            IdNumber: 'required',
            LastName: 'required',
            FirstName: 'required',
            AddressLineOne: 'required',
            AddressLineTwo: 'required',
            PostCode: 'required|numeric',
            EmailAddress: 'required|email',
            MaritalStatus: 'required|numeric',
            CellPhoneNumber: 'required|numeric'
        };

        if (!this.isLegalEntity) {
            results = this.purchaserValidation(rules, customErrorMessages);
        } else {
            results = this.contactPersonValidation(rules, customErrorMessages);
        }

        results = { ...results, header: this.headerValidation(customErrorMessages) };

        return results;
    }

    headerValidation(customErrorMessages) {
        let results = [];
        const name = this.clearanceHeader.name,
            postCode = this.clearanceHeader.postCode,
            AttorneyRef = this.clearanceHeader.AttorneyRef,
            registrationNo = this.clearanceHeader.registrationNo,
            addressLineOne = this.clearanceHeader.addressLineOne,
            addressLineTwo = this.clearanceHeader.addressLineTwo,
            dateValidUntil = this.clearanceHeader.dateValidUntil,
            addressLineThree = this.clearanceHeader.addressLineThree,
            selectedEntityType = this.clearanceHeader.selectedEntityType,
            selectedLegalEntity = this.clearanceHeader.selectedLegalEntity,
            selectedPurchaserType = this.clearanceHeader.selectedPurchaserType,
            SellerBankName = this.clearanceHeader.SellerBankName,
            SellerBankAccountName = this.clearanceHeader.SellerBankAccountName,
            SellerBankAccountNumber = this.clearanceHeader.SellerBankAccountNumber,
            SellerBankBranchCode = this.clearanceHeader.SellerBankBranchCode;

        const inputs = {
            AttorneyRef,
            dateValidUntil,
            selectedEntityType,
            selectedPurchaserType,
            SellerBankName,
            SellerBankAccountName,
            SellerBankAccountNumber,
            SellerBankBranchCode,
        };

        const otherInputs = {
            name,
            postCode,
            registrationNo,
            addressLineOne,
            addressLineTwo,
            addressLineThree,
            selectedLegalEntity
        };

        const normalRules = {
            AttorneyRef: 'required',
            dateValidUntil: 'required',
            selectedEntityType: 'required',
            selectedPurchaserType: 'required',
            SellerBankName: 'required',
            SellerBankAccountName: 'required',
            SellerBankAccountNumber: 'required|numeric',
            SellerBankBranchCode: 'required|numeric'
        };

        const legalEntityRules = {
            name: 'required',
            postCode: 'required',
            AttorneyRef: 'required',
            addressLineOne: 'required',
            registrationNo: 'required',
            addressLineTwo: 'required',
            dateValidUntil: 'required',
            addressLineThree: 'required',
            selectedLegalEntity: 'required',
            selectedPurchaserType: 'required',
            SellerBankName: 'required',
            SellerBankAccountName: 'required',
            SellerBankAccountNumber: 'required|numeric',
            SellerBankBranchCode: 'required|numeric'
        };

        const displayLabels = {
            postCode: 'Postal Code',
            dateValidUntil: 'Valid Until',
            name: this.displayLabelForName,
            addressLineOne: 'Address Line 1',
            addressLineTwo: 'Address Line 2',
            addressLineThree: 'Address Line 3',
            registrationNo: 'Registration No.',
            AttorneyRef: 'Attorney Reference #',
            selectedEntityType: 'Type of Purchase',
            selectedPurchaserType: 'Type of Entity',
            selectedLegalEntity: 'Type of Legal Entity',
            SellerBankName: 'Seller Bank Name',
            SellerBankAccountName: 'Seller Bank Account Holder Name',
            SellerBankAccountNumber: 'Seller Bank Account Number',
            SellerBankBranchCode: 'Seller Bank Branch Code'
        };

        const rules =
            this.clearanceHeader.selectedLegalEntity == 1 ||
                this.clearanceHeader.selectedLegalEntity == 2 ||
                this.clearanceHeader.selectedLegalEntity == 3
                ? legalEntityRules
                : normalRules;

        const fieldsForValidation =
            this.clearanceHeader.selectedLegalEntity &&
                (this.clearanceHeader.selectedLegalEntity == 1 ||
                    this.clearanceHeader.selectedLegalEntity == 2 ||
                    this.clearanceHeader.selectedLegalEntity == 3)
                ? { ...inputs, ...otherInputs }
                : inputs;

        const validator = new Validator(fieldsForValidation, rules, customErrorMessages);
        validator.setAttributeNames(displayLabels);

        validator.passes();
        if (validator.errorCount > 0) {
            Object.keys(validator.errors.errors).forEach((name) => {
                const error = validator.errors.first(name);
                results = [...results, error];
            });
        }

        return results;
    }

    purchaserValidation(rules, customErrorMessages) {
        let results = {
            first: [],
            second: []
        };

        if (
            this.ClearanceCaptureService.clearanceCapture.Purchaser &&
            this.ClearanceCaptureService.clearanceCapture.Purchaser.length > 0
        ) {
            this.ClearanceCaptureService.clearanceCapture.Purchaser.forEach((purchaser, index) => {
                const {
                    PostCode,
                    IdNumber,
                    LastName,
                    FirstName,
                    EmailAddress,
                    MaritalStatus,
                    AddressLineOne,
                    AddressLineTwo,
                    CellPhoneNumber,
                    OtherMaritalStatus
                } = purchaser;
                const inputs = {
                    PostCode,
                    IdNumber,
                    LastName,
                    FirstName,
                    EmailAddress,
                    MaritalStatus,
                    AddressLineOne,
                    AddressLineTwo,
                    CellPhoneNumber
                };
                const inputsDisplayLabels = {
                    PostCode: 'Post Code',
                    LastName: 'Last Name',
                    FirstName: 'First Name',
                    EmailAddress: 'Email Address',
                    MaritalStatus: 'Marital Status',
                    IdNumber: 'ID Number or Passport',
                    OtherMaritalStatus: 'Specify other',
                    CellPhoneNumber: 'Cell Phone Number',
                    AddressLineTwo: 'Postal Address Line 2',
                    AddressLineOne: 'Postal Address Line 1'
                };

                if (MaritalStatus == -1) {
                    rules.OtherMaritalStatus = 'required';
                    inputs.OtherMaritalStatus = OtherMaritalStatus;
                }
                const validator = new Validator(inputs, rules, customErrorMessages);
                validator.setAttributeNames(inputsDisplayLabels);
                validator.passes();
                if (validator.errorCount > 0) {
                    Object.keys(validator.errors.errors).forEach((name) => {
                        const error = validator.errors.first(name);
                        if (index === 0) {
                            results.first = [...results.first, error];
                        } else {
                            results.second = [...results.second, error];
                        }
                    });
                }
            });
        } else {
            results.first = ['Please add one or more purchaser(s)'];
        }

        return results;
    }

    contactPersonValidation(rules, customErrorMessages) {
        let results = {
            first: [],
            second: []
        };

        if (
            this.ClearanceCaptureService.clearanceCapture.LegalEntity.ContactPerson &&
            this.ClearanceCaptureService.clearanceCapture.LegalEntity.ContactPerson.length > 0
        ) {
            this.ClearanceCaptureService.clearanceCapture.LegalEntity.ContactPerson.forEach((purchaser, index) => {
                const {
                    PostCode,
                    IdNumber,
                    LastName,
                    FirstName,
                    EmailAddress,
                    MaritalStatus,
                    AddressLineOne,
                    AddressLineTwo,
                    CellPhoneNumber,
                    OtherMaritalStatus
                } = purchaser;
                const inputs = {
                    PostCode,
                    IdNumber,
                    LastName,
                    FirstName,
                    EmailAddress,
                    MaritalStatus,
                    AddressLineOne,
                    AddressLineTwo,
                    CellPhoneNumber
                };
                const inputsDisplayLabels = {
                    PostCode: 'Post Code',
                    LastName: 'Last Name',
                    FirstName: 'First Name',
                    EmailAddress: 'Email Address',
                    MaritalStatus: 'Marital Status',
                    IdNumber: 'ID Number or Passport',
                    OtherMaritalStatus: 'Specify other',
                    CellPhoneNumber: 'Cell Phone Number',
                    AddressLineTwo: 'Postal Address Line 2',
                    AddressLineOne: 'Postal Address Line 1'
                };

                if (MaritalStatus == -1) {
                    rules.OtherMaritalStatus = 'required';
                    inputs.OtherMaritalStatus = OtherMaritalStatus;
                }
                const validator = new Validator(inputs, rules, customErrorMessages);
                validator.setAttributeNames(inputsDisplayLabels);
                validator.passes();
                if (validator.errorCount > 0) {
                    Object.keys(validator.errors.errors).forEach((name) => {
                        const error = validator.errors.first(name);
                        if (index === 0) {
                            results.first = [...results.first, error];
                        } else {
                            results.second = [...results.second, error];
                        }
                    });
                }
            });
        } else {
            results.first = [`Please add one or more ${this.displayLabelForPurchaser.replace(`'s`, '')}(s)`];
        }

        return results;
    }

    async submitClearanceCapture() {
        this._switchIsBusy(true);

        try {
            await this.ClearanceCaptureService.submitClearanceCapture(this.ClearanceCaptureService.clearanceCapture.Id);
            this.clearPage();
            this.getClearanceHeaderInformation();
            this.NotificationService.success('CLEARANCE DETAILS SUBMITTED');
        } catch (error) {
            console.error(error);
            this._switchIsBusy(false);
            this.NotificationService.error('CLEARANCE DETAILS COULD NOT BE SUBMITTED');
        } finally {
            this._switchIsBusy(false);
        }
    }

    addMainAttachmentWatch() {
        this.$timeout(() => {
            $('input[type=file].mainAttachmentBrowseFile').each((i, el) => $(el).off('change'));
            $('input[type=file].mainAttachmentBrowseFile').each((i, el) =>
                $(el).on('change', (evt) => {
                    const $target = $(evt.target);
                    const container = $target.closest('div[files-drop]');
                    const attrs = container.attr('files-drop').toLowerCase();

                    let type = 0;

                    if (attrs.includes('hoa membership form')) {
                        type = 3;
                    } else if (attrs.includes('company registration document')) {
                        type = 4;
                    } else if (attrs.includes('proof of payment')) {
                        type = 5;
                    } else if (attrs.includes('acknowledgment of rules')) {
                        type = 6;
                    } else if (attrs.includes('registration document')) {
                        type = 7;
                    } else if (attrs.includes('seller banking confirmation')) {
                        type = 8;
                    } else if (attrs.includes('additional documents')) {
                        type = 9;
                    }

                    if (type == 0) {
                        console.error('Cant determine doc type. All hell is about to break lose.');
                    }

                    const file = evt.target.files[0];

                    this.readAndStore(file, type);
                })
            );
        }, 1000);
    }

    addPersonAttachmentWatch() {
        this.$timeout(() => {
            $('input[type=file].purchaserAttachmentBrowseFile').each((i, el) => $(el).off('change'));
            $('input[type=file].purchaserAttachmentBrowseFile').each((i, el) =>
                $(el).on('change', (evt) => {
                    const $target = $(evt.target);
                    const container = $target.closest('div[files-drop]');
                    const attrs = container.attr('files-drop').toLowerCase();

                    const type = this.documentTypeList.find((docType) =>
                        attrs.includes(docType.Description.toLowerCase())
                    ).Value;

                    const file = evt.target.files[0];
                    this.readAndStore(file, type);
                })
            );
        }, 1000);
    }

    handleDrop(files, type) {
        if (!this.disableFileUpload()) {
            this.uploadFile(files[0]);
        }
    }

    populatePurchaserForm(id, evt) {
        this._switchIsPurchaserBusy(true);
        this.isInAddPurchaserMode = false;
        this.isInEditPurchaserMode = true;
        this.selectedPurchaserId = id;
        this.getPurchaser();
    }

    showAddPurchaser(evt) {
        $('#purchaserInformation span').removeClass('purchaser-tab-selected');
        if (evt) {
            $(evt.target).addClass('purchaser-tab-selected');
        }

        this.addPersonAttachmentWatch();

        this.documentTypeList = [
            {
                Value: 1,
                Description: 'Id Document'
            },
            {
                Value: 2,
                Description: 'Proof Of Residence'
            }
        ];

        this.isInAddPurchaserMode = true;
        this.isInEditPurchaserMode = false;
        this.purchaser = {};

        const $purchaserInfo = $('#purchaserInformation');

        $('html, body').animate({
            scrollTop: $purchaserInfo.position().top
        });
    }

    createPersonAttachmentList() {
        this.documentTypeList = [
            {
                Value: 1,
                Description: 'Id Document'
            },
            {
                Value: 2,
                Description: 'Proof Of Residence'
            }
        ];
        this.documentTypeListLoaded = [{}];
        this.documentType = '0';
        if (this.isLegalEntity) {
            if (
                this.purchaser &&
                this.purchaser.ContactPersonAttachment &&
                this.purchaser.ContactPersonAttachment.length > 0
            ) {
                this.purchaser.ContactPersonAttachment.forEach((attachment) => {
                    const docType = {
                        Value: attachment.ClearanceDocumentType,
                        Description: attachment.DocumentTypeDescription
                    };

                    this.documentTypeListLoaded.push(docType);
                });
            }
        } else {
            if (this.purchaser.PurchaserAttachment && this.purchaser.PurchaserAttachment.length > 0) {
                this.purchaser.PurchaserAttachment.forEach((attachment) => {
                    const docType = {
                        Value: attachment.ClearanceDocumentType,
                        Description: attachment.DocumentTypeDescription
                    };

                    this.documentTypeListLoaded.push(docType);
                });
            }
        }

        this.documentTypeList = _.differenceBy(this.documentTypeList, this.documentTypeListLoaded, 'Value');
    }

    createMainAttachmentList() {
        // Create list of all docs
        this.purchaseDocTypes.push(this.acknowledgementOfRules);

        if (this.isHoa) {
            this.purchaseDocTypes.push(this.hoaDocument);
        }

        if (this.isLegalEntity) {
            this.purchaseDocTypes = [
                {
                    Value: 4,
                    Description: 'Company Registration Document'
                }
            ];
        }

        this.headerDocumentsAlreadyUpLoaded = [{}];
        this.documentType = '0';
        if (
            this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment &&
            this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment.length > 0
        ) {
            this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment.forEach((attachment) => {
                const docType = {
                    Value: attachment.ClearanceDocumentType,
                    Description: attachment.DocumentTypeDescription
                };

                this.headerDocumentsAlreadyUpLoaded.push(docType);
            });
        }

        if (
            this.ClearanceCaptureService.clearanceCapture.LegalEntity &&
            this.ClearanceCaptureService.clearanceCapture.LegalEntity.LegalEntityAttachment &&
            this.ClearanceCaptureService.clearanceCapture.LegalEntity.LegalEntityAttachment.length > 0
        ) {
            this.ClearanceCaptureService.clearanceCapture.LegalEntity.LegalEntityAttachment.forEach((attachment) => {
                const docType = {
                    Value: attachment.ClearanceDocumentType,
                    Description: attachment.DocumentTypeDescription
                };

                this.headerDocumentsAlreadyUpLoaded.push(docType);
            });
        }

        this.purchaseDocTypes = _.differenceBy(this.purchaseDocTypes, this.headerDocumentsAlreadyUpLoaded, 'Value');
    }

    async getPurchaser() {
        let promise;

        if (this.isLegalEntity) {
            await this.ClearanceCaptureService.getContactPerson(this.selectedPurchaserId);
            this.purchaser = this.ClearanceCaptureService.contactPersonData;
            this.createPersonAttachmentList();
            this.addPersonAttachmentWatch();
            this.addMainAttachmentWatch();
            this._switchIsPurchaserBusy(false);
        } else {
            await this.ClearanceCaptureService.getPurchaser(this.selectedPurchaserId);
            this.purchaser = this.ClearanceCaptureService.purchaserData;
            this.createPersonAttachmentList();
            this.addPersonAttachmentWatch();
            this.addMainAttachmentWatch();
            this._switchIsPurchaserBusy(false);
        }

        this.$timeout(() => {
            this._switchIsBusy(false);
            this.setCurrentPurchaserTabFocus();
        });
    }

    setCurrentPurchaserTabFocus() {
        const $tabSection = $('#purchaserInformation');
        $('span.purchaser-tab', $tabSection).each((i, el) => $(el).removeClass('purchaser-tab-selected'));

        if (!this.purchaser) {
            return;
        }

        const { Id } = this.purchaser;

        $(`#${Id}`, $tabSection).addClass('purchaser-tab-selected');
    }

    async savePurchaser() {
        this.isInAddPurchaserMode = false;

        this._switchIsPurchaserBusy(true);
        if (this.isLegalEntity) {
            this.purchaser.LegalEntityId = this.ClearanceCaptureService.clearanceCapture.LegalEntity.Id;
            await this.ClearanceCaptureService.upsertContactPerson(this.purchaser);
            this.purchaser = this.ClearanceCaptureService.contactPersonData;
            this.selectedPurchaserId = this.purchaser.Id;
            this.attachment.ContactPersonId = this.purchaser.Id;
            this.addAttachment();
        } else {
            this.purchaser.ClearanceHeaderId = this.ClearanceCaptureService.clearanceCapture.Id;
            await this.ClearanceCaptureService.upsertPurchaser(this.purchaser);
            this.purchaser = this.ClearanceCaptureService.purchaserData;
            this.selectedPurchaserId = this.purchaser.Id;
            this.attachment.PurchaserId = this.purchaser.Id;
            this.addAttachment();
        }

        this.submitErrorMessage = '';
        this.inputForm.$setPristine();

        this.isInEditPurchaserMode = true;
    }

    async deletePurchaser() {
        this.hideModal('deletePurchaserNag');
        this._switchIsPurchaserBusy(true);
        if (this.isLegalEntity) {
            await this.ClearanceCaptureService.deleteContactPerson(this.purchaser.Id);
            this.getClearanceHeaderInformation();
            this.clearPage();
            this._switchIsPurchaserBusy(false);
        } else {
            await this.ClearanceCaptureService.deletePurchaser(this.purchaser.Id);
            this.getClearanceHeaderInformation();
            this.clearPage();
            this._switchIsPurchaserBusy(false);
        }
    }

    selectFile(id) {
        const file = $('input[type=file]#' + id)[0].files[0];
        this.uploadFile(file);
    }

    uploadFile(file) {
        if (file) {
            this.readAndStore(file);
        } else {
            console.error('No file And/Or purchaser', this.purchaser);
        }

        $('input[type=file]').each((i, el) => $(el).val(''));
    }

    readAndStore(file, type) {
        if (file.type !== 'application/pdf') {
            const errorMsg = 'Wrong file type, only PDFs are allowed.';
            this.NotificationService.error(errorMsg);

            console.error(
                `${errorMsg} "${file.name}" is not in the correct format for ${type} - only PDFs are allowed.`
            );

            angular.element('[type=file]').each((i, el) => {
                angular.element(el).off('change');
                angular.element(el).val(null);
            });

            this.addMainAttachmentWatch();
            this.addPersonAttachmentWatch();
        }
        else if (file.name.length > 50) {
            const errorMsg = 'Filename too long. Please shorten your filename to less than 50 characters.';
            this.NotificationService.error(errorMsg);

            console.error(
                `Filename too long. Please shorten your filename to less than 50 characters.`
            );

            angular.element('[type=file]').each((i, el) => {
                angular.element(el).off('change');
                angular.element(el).val(null);
            });

            this.addMainAttachmentWatch();
            this.addPersonAttachmentWatch();
        }
        else if (file.size > 5242880) {
            const errorMsg = 'File size too large. Please reduce the size of your file to smaller than 5 mega bytes.';
            this.NotificationService.error(errorMsg);

            console.error(
                `File size too large. Please reduce the size of your file to smaller than 5 mega bytes.`
            );

            angular.element('[type=file]').each((i, el) => {
                angular.element(el).off('change');
                angular.element(el).val(null);
            });

            this.addMainAttachmentWatch();
            this.addPersonAttachmentWatch();
        }
        else {
            const reader = new FileReader();
            reader.onload = () => {
                const description = file.name.replace(file.name.substr(file.name.lastIndexOf('.')), '');
                const isHeader =
                    (this.purchaseDocumentType == 3 ||
                        this.purchaseDocumentType == 5 ||
                        this.purchaseDocumentType == 6) &&
                    this.documentType == 0;
                const docType = type || parseInt(isHeader ? this.purchaseDocumentType : this.documentType);

                this.attachment = {
                    FileName: description,
                    ClearanceDocumentType: docType,
                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                };

                if (docType == 1 || docType == 2) {
                    this.savePurchaser();
                } else if (docType == 4) {
                    this.attachment.LegalEntityId = this.clearanceHeader.legalEntityId;
                    this.saveClearanceHeader();
                } else if (docType == 3 || docType == 5 || docType == 6 || docType == 8 || docType == 9) {
                    this.attachment.ClearanceHeaderId = this.clearanceHeader.Id;
                    this.saveClearanceHeader();
                } else if (docType == 7) {
                    this.attachment.ClearanceHeaderId = this.clearanceHeader.Id;
                    this.saveClearanceRegHeaderAttachment();
                } else {
                    console.error('No valid docType');
                }
            };

            reader.readAsArrayBuffer(file);
        }
    }

    async addAttachment() {
        if (this.attachment && this.attachment.Blob != undefined) {
            const docType = this.attachment.ClearanceDocumentType;
            await this.ClearanceCaptureService.addAttachment(this.attachment, docType, this.isLegalEntity);
            if (docType == 1 || docType == 2) {
                this.getPurchaser();
            } else if (docType == 3 || docType == 4 || docType == 5 || docType == 6 || docType == 7 || docType == 8 || docType == 9) {
                this.getClearanceHeaderInformation();
            }
        } else {
            this.getClearanceHeaderInformation();
        }
    }

    deleteAttachmentNag(attachment) {
        this.selectedAttachment = attachment;
    }

    async deleteAttachment() {
        this.hideModal();
        this._switchIsBusy(true);
        const docType = this.selectedAttachment.ClearanceDocumentType;
        const isLegalEntity =
            this.entityTypes.find((type) => {
                if (type.value.toString() === this.clearanceHeader.selectedEntityType) {
                    return type;
                }
            }).value === 'legal-entity'
                ? true
                : false;

        await this.ClearanceCaptureService.deleteAttachment(this.selectedAttachment, isLegalEntity);
        if (docType == 3 || docType == 4 || docType == 5 || docType == 6 || docType == 7 || docType == 8 || docType == 9) {
            this.getClearanceHeaderInformation();
        } else if (docType == 1 || docType == 2) {
            this.getPurchaser();
        }
    }

    hideModal(modal = 'deleteAttachmentNag') {
        const $modal = $(`#${modal}`);
        $modal.on('hide.bs.modal', () => {
            $('div.modal-backdrop.fade.in').each((i, el) => {
                const $el = $(el);
                const id = $el.attr('id');

                if (!id) {
                    $el.remove();
                    $('body').attr('style', `overflow-y:visible !important`);
                }
            });
        });

        $modal.modal('hide');
    }

    getMarriageStatus(status) {
        if (status === 1) return 'Single';
        if (status === 2) return 'Married';
        if (status === 3) return 'Divorced';
        if (status === 4) return 'Widowed';
        return 'Unknown';
    }

    formatTextWithNewLine(text, noNewLine) {
        if (text.length > 0) {
            if (noNewLine) {
                return `${text}`;
            }

            return `${text}\r\n`;
        }

        return '';
    }

    clearPage() {
        this._switchIsPurchaserBusy(false);
        this.isInAddPurchaserMode = false;
        this.isInEditPurchaserMode = false;
        this.hasSelectedPurchaser = false;
        this.selectedPurchaserId = '';
        this.selectedPurchaser = '';
        this.validPurchaser = false;
        this.purchaserConfirms = false;
        this.documentType = '0';
        this.selectedAttachment = {};
        this.documentTypeList = [
            {
                Value: 1,
                Description: 'Id Document'
            },
            {
                Value: 2,
                Description: 'Proof Of Residence'
            }
        ];
        this.documentTypeListLoaded = [{}];

        this.defineDefaultPurchaser();

        $('#purchaserAttachmentBrowseFile').val('');
        $('#mainAttachmentBrowseFile').val('');
    }

    defineDefaultPurchaser() {
        this.purchaser = {
            Id: '',
            LastName: '',
            IdNumber: '',
            PostCode: '',
            FirstName: '',
            AddressOne: '',
            AddressTwo: '',
            AddressFour: '',
            EmailAddress: '',
            AddressThree: '',
            ContactNumber: '',
            ClearanceAttachment: {},
            MaritalStatus: undefined
        };
        this.clearanceHeader = {
            postCode: null,
            vatRegNo: null,
            attachments: [],
            addressLineTwo: '',
            addressLineOne: '',
            addressLineFour: '',
            addressLineThree: '',
            registrationNo: null,
            dateValidUntil: null,
            selectedEntityType: null,
            selectedLegalEntity: null,
            pretorToHandleRental: true,
            selectedPurchaserType: null,
            dateOfRegistration: null,
            SellerBankName: '',
            SellerBankAccountName: '',
            SellerBankAccountNumber: '',
            SellerBankBranchCode: ''
        };
    }

    disableFileUpload() {
        return !(this.documentType != 0 && (this.inputForm && this.inputForm.$valid));
    }

    allowUploadPurchaserDocument(type) {
        if (!type) {
            return true;
        }
        if (this.isPurchaserBusy) {
            return false;
        }

        const purchaseDocTypes = [
            {
                Value: 1,
                Description: 'Id Document'
            },
            {
                Value: 2,
                Description: 'Proof Of Residence'
            }
        ];

        const docType = purchaseDocTypes.find((dt) => dt.Description.toLowerCase() === type.toLowerCase()).Value;

        let hasDoc;

        if (!this.ClearanceCaptureService.clearanceCapture.IsLegalEntity) {
            hasDoc = !!(this.purchaser && this.purchaser.PurchaserAttachment
                ? this.purchaser.PurchaserAttachment.find((doc) => doc.ClearanceDocumentType == docType)
                : null);
        } else {
            hasDoc = !!(this.purchaser && this.purchaser.ContactPersonAttachment
                ? this.purchaser.ContactPersonAttachment.find((doc) => doc.ClearanceDocumentType == docType)
                : null);
        }

        return !hasDoc;
    }

    allowUploadHeaderDocument(type) {
        if (!type) {
            return true;
        }

        const headerTypes = [
            {
                Value: 3,
                Description: 'Hoa Membership Form'
            },
            {
                Value: 4,
                Description: 'Company Registration Document'
            },
            {
                Value: 5,
                Description: 'Proof Of Payment'
            },
            {
                Value: 6,
                Description: 'Acknowledgment Of Rules'
            },
            {
                Value: 7,
                Description: 'Registration Document'
            },
            {
                Value: 8,
                Description: 'Seller Banking Confirmation'
            }

        ];

        const docType = headerTypes.find((dt) => dt.Description.toLowerCase() === type.toLowerCase()).Value;

        if (docType === 4) {
            if (
                this.ClearanceCaptureService.clearanceCapture.LegalEntity &&
                this.ClearanceCaptureService.clearanceCapture.LegalEntity.LegalEntityAttachment &&
                (this.ClearanceCaptureService.clearanceCapture.LegalEntity &&
                    this.ClearanceCaptureService.clearanceCapture.LegalEntity.LegalEntityAttachment.length > 0)
            ) {
                return false;
            } else {
                return true;
            }
        } else {
            let isDocumentUploaded =
                this.ClearanceCaptureService.clearanceCapture &&
                    this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment &&
                    this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment.length > 0
                    ? this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment.filter(
                        (dt) => dt.ClearanceDocumentType == docType
                    )
                    : [];
            if (isDocumentUploaded && isDocumentUploaded.length > 0) {
                return false;
            } else {
                return true;
            }
        }
    }

    canUploadDocumentsNew() {
        const allow = this.purchaseDocumentType != '0' && (this.headerForm && this.headerForm.$valid);

        return allow;
    }

    async showRules(schemeReference) {
        await this.ClearanceCaptureService.getConductRulesOrMemoForScheme(schemeReference);
    }

    get isHoa() {
        return this.ClearanceCaptureService.clearanceCapture.IsHOA;
    }

    get isRegistrationSubmitted() {
        let returnVal = false;

        if (this.ClearanceCaptureService.clearanceCapture) {
            if (this.ClearanceCaptureService.clearanceCapture.IsRegistrationSubmitted) {
                returnVal = true;
            }
            else {
                returnVal = false;
            }
        }

        return returnVal;
    }

    get isSubmitted() {
        let returnVal = false;

        if (this.ClearanceCaptureService.clearanceCapture) {
            if (this.ClearanceCaptureService.clearanceCapture.IsSubmitted) {
                returnVal = true;
            }
            else {
                returnVal = false;
            }
        }

        return returnVal;
    }

    get generateRules() {
        const {
            SchemeName,
            HOASchemeName,
            SchemeReference,
            HOASchemeReference
        } = this.ClearanceCaptureService.clearanceCapture;

        const schemeRules = `<a href="#" class="clearance-rules-label" ng-click="clearanceCaptureVm.showRules('${SchemeReference}')">${SchemeName}</a>`;
        const hoaRules = `<a href="#" class="clearance-rules-label" ng-click="clearanceCaptureVm.showRules('${HOASchemeReference}')">${HOASchemeName}</a>`;

        let rules;
        if (SchemeReference && HOASchemeReference) {
            rules = `${schemeRules} as well as ${hoaRules}`;
        } else if (SchemeReference) {
            rules = schemeRules;
        } else {
            rules = hoaRules;
        }
        return rules;
    }
    get requiredDocuments() {
        const docs = this.documentTypeList.filter((dt) => dt.Value != 3);
        return _.map(docs, 'Description');
    }

    get requiredHeaderDocuments() {
        let docRequiredForHeader = [this.hoaDocument, this.acknowledgementOfRules, this.companyRegistrationDocument];

        if (!this.isLegalEntity) {
            docRequiredForHeader = docRequiredForHeader.filter((dt) => dt.Value != 4);
        }

        if (!this.isHoa) {
            docRequiredForHeader = docRequiredForHeader.filter((dt) => dt.Value != 3);
        }

        this.headerDocumentsAlreadyUpLoaded = [{}];
        this.documentType = '0';
        if (
            this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment &&
            this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment.length > 0
        ) {
            this.ClearanceCaptureService.clearanceCapture.ClearanceHeaderAttachment.forEach((attachment) => {
                const docType = {
                    Value: attachment.ClearanceDocumentType,
                    Description: attachment.DocumentTypeDescription
                };

                this.headerDocumentsAlreadyUpLoaded.push(docType);
            });
        }

        if (
            this.ClearanceCaptureService.clearanceCapture.LegalEntity &&
            this.ClearanceCaptureService.clearanceCapture.LegalEntity.LegalEntityAttachment &&
            this.ClearanceCaptureService.clearanceCapture.LegalEntity.LegalEntityAttachment.length > 0
        ) {
            this.ClearanceCaptureService.clearanceCapture.LegalEntity.LegalEntityAttachment.forEach((attachment) => {
                const docType = {
                    Value: attachment.ClearanceDocumentType,
                    Description: attachment.DocumentTypeDescription
                };

                this.headerDocumentsAlreadyUpLoaded.push(docType);
            });
        }

        let docs = _.differenceBy(docRequiredForHeader, this.headerDocumentsAlreadyUpLoaded, 'Value');
        return _.map(docs, 'Description');
    }

    get displayLabelForPurchaser() {
        let label = `Purchaser's`;
        if (this.clearanceHeader.selectedLegalEntity == '1') {
            label = "Member's";
        } else if (this.clearanceHeader.selectedLegalEntity == '2') {
            label = "Contact Person's";
        } else if (this.clearanceHeader.selectedLegalEntity == '3') {
            label = "Director's";
        }

        return label;
    }

    get displayLabelForName() {
        let label = '';
        if (this.clearanceHeader.selectedLegalEntity == '1') {
            label = 'Close Corporation';
        } else if (this.clearanceHeader.selectedLegalEntity == '2') {
            label = 'Trust';
        } else if (this.clearanceHeader.selectedLegalEntity == '3') {
            label = 'Company';
        }

        return `${label || 'Company'} Name`;
    }

    get hasErrors() {
        const hasFormsErrors =
            this.formsErrors &&
            this.formsErrors.first.length === 0 &&
            this.formsErrors.second.length === 0 &&
            this.formsErrors.header.length === 0;

        const hasDocumentsErrors =
            this.documentsErrors &&
            this.documentsErrors.first.length === 0 &&
            this.documentsErrors.second.length === 0 &&
            this.documentsErrors.header.length === 0;

        const foundErrors = hasFormsErrors && hasDocumentsErrors;
        return !foundErrors;
    }

    get areFormsDirty() {
        return this.inputForm.$dirty || this.headerForm.$dirty;
    }

    _updateDatePicker() {
        this.$rootScope.$eval(() => {
            this.$timeout(() => {
                const selector = '.date-picker';
                const $input = $(selector);

                $input.datepicker('update');
            });
        });
    }

    _initializeDatePicker() {
        this.$timeout(() => {
            const selector = '.date-picker';
            const $purchasorInput = $(selector, $('#purchaseInformationForm'));

            let dateNow = new Date();
            let minimumDate = moment(dateNow).startOf('month').add(2, 'M').toDate();
            if (dateNow.getDay() > 15) {
                minimumDate = moment(minimumDate).add(1, 'M').toDate();
            }

            const startDate = moment(minimumDate).toDate();
            const endDate = '+20y';

            const purchasorInputOptions = {
                startDate,
                endDate,
                autoclose: true,
                forceParse: true,
                container: selector,
                format: "yyyy-mm",
                startView: "months",
                minViewMode: "months",
                assumeNearbyYear: true,
                enableOnReadonly: true,
            };

            $purchasorInput.datepicker(purchasorInputOptions);

            const selector1 = '#date-picker-reg';
            const $regInput = $(selector1, $('#uploadRegistrationForm'));

            const regInputOptions = {
                autoclose: true,
                forceParse: true,
                container: selector1,
                format: 'yyyy-mm-dd',
                assumeNearbyYear: true,
                enableOnReadonly: true
            };

            $regInput.datepicker(regInputOptions);
        });
    }

    _switchIsBusy(flag) {
        this.$timeout(() => {
            this.isBusy = flag;
        });
    }

    _switchIsPurchaserBusy(flag) {
        this.$timeout(() => {
            this.isPurchaserBusy = flag;
        });
    }
}
